import axios from "./axios";

export default {
    getInvoicesLiquidationType(filter) {
        const options = {
            method: 'GET',
            url: 'liquidaciones/getInvoicesLiquidationType',
            headers: {'content-type': 'application/json'},
            params: filter
        }

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getInvoicesLiquidationTypeFiltering(filter) {
        const options = {
            method: 'GET',
            url: 'liquidaciones/getInvoicesLiquidationTypeFiltering',
            headers: {'content-type': 'application/json'},
            params: filter
        }

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getInvoicesForLiquidation(filter) {
        const options = {
            method: 'GET',
            url: 'liquidaciones/getInvoicesForLiquidation',
            headers: {'content-type': 'application/json'},
            params: filter
        }

        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    getInvoicesForLiquidationFiltering(filter) {
        const options = {
            method: 'GET',
            url: 'liquidaciones/getInvoicesForLiquidationFiltering',
            headers: {'content-type': 'application/json'},
            params: filter
        }
        
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
    posCreateComprobanteContableLiquidacion(data) {
        const options = {
            method: 'POST',
            url: `liquidaciones/posCreateComprobanteContableLiquidacion`,
            headers: {'content-type': 'application/json'},
            data: data,
            timeout: 60000
        };
        return new Promise((resolve, reject) => {
            axios(options)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                if (error.response) {
                    reject(error.response.data)
                }
                else {
                    reject({
                        status: 500,
                        success: false,
                        data: error
                    })
                }
            })
        })
    },
    posCreateComprobanteDeLiquidacion(data) {
        const options = {
            method: 'POST',
            url: `liquidaciones/posCreateComprobanteDeLiquidacion`,
            headers: {'content-type': 'application/json'},
            data: data,
            timeout: 60000
        };
        return new Promise((resolve, reject) => {
            axios(options)
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                if (error.response) {
                    reject(error.response.data)
                }
                else {
                    reject({
                        status: 500,
                        success: false,
                        data: error
                    })
                }
            })
        })
    },
    getInvoicesByDocRelated(data) {
        const options = {
            method: 'GET',
            url: 'liquidaciones/getInvoicesByDocRelated',
            headers: {'content-type': 'application/json'},
            params: data
        }
        
        return new Promise((resolve, reject) => {
            axios(options)
                .then(response => {
                    resolve(response.data);
                })
                .catch(error => {
                    reject(error.message)
                })
        })
    },
}